import { CircularProgress, Stack } from '@mui/material';

// TODO: make a loading variant that doesnt take up the whole page width
interface ILoadingProps {
  height?: string;
  width?: string;
  padding?: number;
}

function Loading({ height, width, padding = 0 }: ILoadingProps) {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: height ?? '100%',
        width: width ?? '100%',
        padding: padding,
      }}
    >
      <CircularProgress />
    </Stack>
  );
}

export default Loading;
